import {useState, useEffect} from 'react'
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDBadge from 'components/MDBadge';

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Link } from "react-router-dom";
import { Divider } from '@mui/material';

// @mui material components
import Card from "@mui/material/Card";
import MDTypography from 'components/MDTypography';
/* eslint-disable react/prop-types */
function Reports() {

  return (
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <Card sx={{ mt:2, padding: "2rem", mb:3}}>
      <MDBox py={1} >
      <MDBox>
        <MDTypography variant="h6" fontWeight="medium" color="text" gutterBottom>
          Your reports results for the following campaigns are ready!
        </MDTypography>
      </MDBox>
        <MDBox mt={4.5} ml={3}>
          <Grid container spacing={3}>
            <MDBox display="flex">
            <Card sx={{ mt:2, padding: "1.5rem", backgroundColor:"#F8F9FA"}}>
              <Card sx={{padding: "2rem"}}>
                <MDBox display="flex" justifyContent="right" mb={2}>
                  <MDBadge badgeContent="default" color="secondary" variant="gradient" size="md" />
                </MDBox>
                <MDTypography variant="h5" fontWeight="medium" gutterBottom>
                    ZARA shop report
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text" gutterBottom>
                    survey report
                </MDTypography>
                <Divider />
                <Link to={"/reports/shop"}>
                  <MDBox display="flex" justifyContent="center" alignItems="center">
                    <MDButton iconOnly={false} sx={{marginLeft:0, padding:1}}>
                        <Icon>visibility</Icon>&nbsp;view
                    </MDButton>
                  </MDBox>
                </Link>
              </Card>
            </Card>
            <Card sx={{ ml:5, mt:2, padding: "1.5rem", backgroundColor:"#F8F9FA"}}>
              <Card  sx={{  padding: "2rem"}}>
                <MDBox display="flex" justifyContent="right" mb={2}>
                    <MDBadge badgeContent="custom" color="success" variant="gradient" size="md" />
                  </MDBox>
                  <MDTypography variant="h5" fontWeight="medium" gutterBottom>
                    LONG PUFFER JACKET product report
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text" gutterBottom>
                    survey report, discount report
                </MDTypography>
                <Divider />
                  <Link to={"/reports/product"}>
                    <MDBox display="flex" justifyContent="center" alignItems="center">
                      <MDButton iconOnly={false} sx={{marginLeft:0, padding:1}}>
                          <Icon>visibility</Icon>&nbsp;view
                      </MDButton>
                    </MDBox>
                  </Link>
              </Card>
            </Card>
            </MDBox>
          </Grid>
        </MDBox>
       
      </MDBox>
      <MDBox mt={6}>
          <MDButton variant="gradient" color="success" size="medium">
            <MDTypography variant="caption" fontWeight="medium" color="light">{" + Create custom report"}</MDTypography>
          </MDButton>
          </MDBox>
      </Card>
      <Footer />
    </DashboardLayout>
    </>
  );
}

export default Reports;
